import { useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import Icon from '../../components/icons.jsx'
import ActivityDeadlinePicker from './ActivityDeadlinePicker.jsx'

export default function ActivityDeadlineField({
  value, onChange, label = 'Prazo da atividade', placeholder = 'Selecionar prazo', clearLabel, timeLabel,
}) {
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState(value)
  const [position, setPosition] = useState({})
  const trigger = useRef(null)
  const popup = useRef(null)
  const close = () => { setOpen(false); trigger.current?.focus() }
  useLayoutEffect(() => {
    if (!open) return
    const place = () => {
      const rect = trigger.current.getBoundingClientRect()
      const width = Math.min(290, window.innerWidth - 16)
      const height = popup.current.offsetHeight
      setPosition({ width, left: Math.max(8, Math.min(rect.left, window.innerWidth - width - 8)), top: Math.max(8, rect.bottom + height + 6 <= window.innerHeight ? rect.bottom + 6 : rect.top - height - 6) })
    }
    const outside = event => {
      if (!popup.current?.contains(event.target) && !trigger.current?.contains(event.target)) setOpen(false)
    }
    place()
    const observer = new ResizeObserver(place)
    observer.observe(popup.current)
    document.addEventListener('pointerdown', outside)
    window.addEventListener('scroll', place, true)
    window.addEventListener('resize', place)
    popup.current.querySelector('button')?.focus()
    return () => {
      observer.disconnect()
      document.removeEventListener('pointerdown', outside)
      window.removeEventListener('scroll', place, true)
      window.removeEventListener('resize', place)
    }
  }, [open])
  return <>
    <button ref={trigger} type="button" className="dp-type-trigger" aria-label={label} aria-haspopup="dialog" aria-expanded={open} onClick={() => { setDraft(value); setOpen(!open) }}>
      <span>{value ? `${['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'][new Date(value).getDay()]} às ${new Date(value).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })} · ${new Date(value).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' })}` : placeholder}</span>
      <span className="dp-field-chevron" aria-hidden="true"><Icon n="calendar" s={14} sw={1.7} /></span>
    </button>
    {open && createPortal(<div ref={popup} role="dialog" aria-label={placeholder} className="dp-activity-inline-editor dp-activity-popover dp-deadline-field-popup" style={position} onBlur={event => {
      if (!event.currentTarget.contains(event.relatedTarget) && !trigger.current?.contains(event.relatedTarget)) setOpen(false)
    }} onKeyDown={event => { if (event.key === 'Escape') { event.stopPropagation(); event.preventDefault(); close() } }}>
      <ActivityDeadlinePicker value={draft} onChange={setDraft} clearLabel={clearLabel} timeLabel={timeLabel} />
      <footer><button type="button" onClick={close}>Cancelar</button><button type="button" onClick={() => { onChange(draft); close() }}>Aplicar</button></footer>
    </div>, document.body)}
  </>
}
